import { OwnerForm } from '@components/owner-form'
import {
  AdasBox,
  AdasButton,
  AdasCard,
  AdasContainer,
  AdasPaper,
  AdasSearchMenu,
  AdasStep,
  AdasStepLabel,
  AdasStepper,
  AdasTextField,
  AdasTypography
} from '@components/wrapper-components'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { UsaStates } from 'usa-states'
import { PACKAGE_TYPE_OPTIONS } from '../../../constants'
import { phoneNumberFormat, validations, zipCodeInput } from '../../../utils/utils'

export const NewCalibrationCenterPage = () => {
  const history = useHistory()
  const [calibrationCenter, setCalibrationCenter] = useState({
    name: '',
    website: '',
    email: '',
    phone: '',
    shop_address: '',
    shop_city: '',
    shop_state: '',
    shop_zip: '',
    shop_country: 'USA',
    package_type: '',
    active: true
  })
  const [locationComplete, setLocationComplete] = useState(false)
  const [activeStep, setActiveStep] = useState(0)
  const [touched, setTouched] = useState({
    name: false,
    email: false,
    phone: false,
    city: false
  })
  const [valid, setValid] = useState({
    name: validations.name(calibrationCenter.name),
    email: validations.email(calibrationCenter.email),
    phone: validations.phone(calibrationCenter.phone),
    city: validations.city(calibrationCenter.shop_city)
  })
  const usStates = new UsaStates()
  const steps = ['Set Up New Location', 'Invite an Owner']
  const isDisabled = () => {
    // `website` and `package_type` are optional, so an empty value for either must
    // not block submission.
    const optionalFields = ['website', 'package_type']
    const filterData = Object.keys(calibrationCenter).filter((key) => !optionalFields.includes(key) && !calibrationCenter[key])
    return filterData.length > 0
  }

  const handleInputChange = (e) => {
    const name = e.target.name === 'shop_city' ? 'city' : e.target.name
    const value = name === 'phone' ? phoneNumberFormat(e.target.value) : name === 'zipCode' ? zipCodeInput(e.target.value) : e.target.value
    setCalibrationCenter((prev) => {
      const calibrationCenter = {
        ...prev,
        [e.target.name]: value
      }
      return calibrationCenter
    })
    setTouched((prev) => {
      return {
        ...prev,
        [name]: true
      }
    })
    setValid((prev) => {
      const valid = {
        ...prev
      }
      if (validations[name]) {
        valid[name] = validations[name](value)
      }
      return valid
    })
  }

  const handleSetCalibrationInfo = () => {
    setActiveStep(1)
    setLocationComplete(true)
  }

  const handleCancel = () => {
    setActiveStep(0)
    setLocationComplete(false)
  }

  return (
    <AdasContainer maxWidth='lg'>
      <AdasCard className='my-5 mx-6 py-4 px-4'>
        <AdasStepper activeStep={activeStep} className='w-full md:w-[60%] flex'>
          {steps.map((label) => {
            return (
              <AdasStep key={label}>
                <AdasStepLabel>{label}</AdasStepLabel>
              </AdasStep>
            )
          })}
        </AdasStepper>
        {!locationComplete ? (
          [
            <AdasPaper key={'formGroup'} variant='outlined' className='p-4 mt-[20px]'>
              <AdasTypography variant='overline' className='inline-block text-xs mb-[20px]'>
                CALIBRATION CENTER CONTACT INFO
              </AdasTypography>
              <AdasBox className='grid grid-cols-1 md:grid-cols-2 gap-x-4'>
                <AdasTextField
                  onChange={handleInputChange}
                  name='name'
                  className='mb-[20px] md:col-span-2'
                  id='name'
                  label='Name *'
                  variant='outlined'
                  value={calibrationCenter.name}
                  error={touched.name && !valid.name}
                  fullWidth={true}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <AdasTextField
                  onChange={handleInputChange}
                  name='email'
                  className='mb-[20px]'
                  id='email'
                  label='Email *'
                  variant='outlined'
                  value={calibrationCenter.email}
                  error={touched.email && !valid.email}
                  fullWidth={true}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <AdasTextField
                  onChange={handleInputChange}
                  name='phone'
                  className='mb-[20px]'
                  id='phone'
                  label='Phone *'
                  variant='outlined'
                  value={calibrationCenter.phone ? phoneNumberFormat(calibrationCenter.phone) : ''}
                  error={touched.phone && !valid.phone}
                  fullWidth={true}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <AdasTextField
                  onChange={handleInputChange}
                  name='website'
                  className='mb-[20px]'
                  id='website'
                  label='Website (Optional)'
                  variant='outlined'
                  value={calibrationCenter.website}
                  fullWidth={true}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <AdasSearchMenu
                  fullWidth
                  id='select-package-type'
                  select
                  label='Package Type (Optional)'
                  variant='outlined'
                  onChange={handleInputChange}
                  className='mb-[20px]'
                  name='package_type'
                  value={calibrationCenter.package_type}
                  InputLabelProps={{
                    shrink: true
                  }}
                  options={PACKAGE_TYPE_OPTIONS}
                />
                <AdasTextField
                  onChange={handleInputChange}
                  name='shop_address'
                  className='mb-[20px] md:col-span-2'
                  id='shop_address'
                  label='Address *'
                  variant='outlined'
                  value={calibrationCenter.shop_address}
                  fullWidth={true}
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{
                    maxLength: 40
                  }}
                />
                <AdasTextField
                  onChange={handleInputChange}
                  name='shop_city'
                  className='mb-[20px]'
                  id='shop_city'
                  label='City *'
                  variant='outlined'
                  value={calibrationCenter.shop_city}
                  error={touched.city && !valid.city}
                  fullWidth={true}
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{
                    maxLength: 28
                  }}
                />
                <AdasSearchMenu
                  fullWidth
                  id='select-state'
                  select
                  label='State *'
                  variant='outlined'
                  onChange={handleInputChange}
                  className='mb-[20px]'
                  name='shop_state'
                  value={calibrationCenter.shop_state}
                  options={usStates?.states?.map((state) => ({
                    value: state.abbreviation,
                    name: state.name
                  }))}
                />
                <AdasTextField
                  onChange={handleInputChange}
                  name='shop_zip'
                  className='mb-[20px]'
                  id='shop_zip'
                  label='Zip *'
                  variant='outlined'
                  value={calibrationCenter.shop_zip}
                  fullWidth={true}
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{
                    maxLength: 5
                  }}
                />
                <AdasSearchMenu
                  onChange={handleInputChange}
                  name='shop_country'
                  select
                  className='mb-[20px]'
                  id='country'
                  label='Country *'
                  variant='outlined'
                  value={calibrationCenter.shop_country}
                  fullWidth={true}
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{
                    maxLength: 25
                  }}
                  options={[{ value: 'USA', name: 'USA' }]}
                />
              </AdasBox>
            </AdasPaper>,
            <AdasBox key={'buttonGroup'} className='overflow-auto my-[20px] mx-0'>
              <AdasBox display='flex' justifyContent='end' gap={2} flexDirection={{ xs: 'column', md: 'row' }}>
                <AdasButton variant='outlined' aria-label='cancel' color='primary' onClick={() => history.goBack()}>
                  Cancel
                </AdasButton>
                <AdasButton
                  disabled={isDisabled()}
                  variant='contained'
                  aria-label='save'
                  color='primary'
                  onClick={handleSetCalibrationInfo}
                >
                  Set Calibration Center Info
                </AdasButton>
              </AdasBox>
            </AdasBox>
          ]
        ) : (
          <OwnerForm cancel={handleCancel} ccInfo={calibrationCenter} />
        )}
      </AdasCard>
    </AdasContainer>
  )
}
